import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { HttpClientModule } from '@angular/common/http';


import {MatStepperModule} from '@angular/material/stepper';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatCardModule} from '@angular/material/card';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';

import { NgxMaskModule } from 'ngx-mask'

import { NgxSpinnerModule } from "ngx-spinner";


import { AppComponent } from './app.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { RegisterComponent } from './register/register.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhoneVerificationComponent } from './phone-verification/phone-verification.component';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { NgMatAutocompleteModule } from './components/autocomplete/autocomplete.module';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from 'src/environments/environment';
import { RegisterParentComponent } from './register-parent/register-parent.component';
import { LeaderboardEmbedComponent } from './leaderboard-embed/leaderboard-embed.component';



@NgModule({
  declarations: [
    AppComponent,
    RegisterComponent,
    RegisterParentComponent,
    PhoneVerificationComponent,
    LeaderboardEmbedComponent
  ],
  imports: [
    BrowserModule,
    NoopAnimationsModule,
    MatStepperModule,
    MatButtonModule,
    HttpClientModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    NgxMaskModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NgMatAutocompleteModule,
    MatIconModule,
    NgxStripeModule.forRoot(environment.stripePublicKey),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
